import React from "react";
import logo from "../assets/otherimages/whitebglogo.jpg";
import {
  FaInstagram,
  FaFacebookF,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaTiktok,
} from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-[#0B2F6B] text-white py-12">
      <div className="max-w-7xl mx-auto  lg:px-10 PX-6">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-10">
          {/* Logo & Contact Info */}
          <div>
            <div className="flex justify-center md:justify-start">
              <img
                src={logo}
                alt="Blue Diamond Rent a Car"
                className="h-16 mb-6"
                loading="lazy"
              />
            </div>
            <ul className="space-y-4 text-sm text-center md:text-left">
              <li className="flex items-start gap-3 justify-center md:justify-start">
                <FaMapMarkerAlt className="text-white text-lg mt-1" />
                <span>
                  6a Street shopno.5 <br />
                  Hafiz Bin Ismail Building, <br />
                  Al Karama, Dubai, United Arab Emirates
                </span>
              </li>
              <li className="flex items-center gap-3 justify-center md:justify-start">
                <FaPhoneAlt className="text-white text-lg" />
                <span>04 - 3974755</span>
              </li>
              <li className="flex items-center gap-3 justify-center md:justify-start">
                <FaEnvelope className="text-white text-lg" />
                <span>sales@bluediamondrentcar.com</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="pl-0 md:pl-10 text-center md:text-left">
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#home" className="hover:text-gray-300">
                  Home
                </a>
              </li>
              <li>
                <a href="#cars" className="hover:text-gray-300">
                  Our Cars
                </a>
              </li>
              <li>
                <a href="#about" className="hover:text-gray-300">
                  About Us
                </a>
              </li>
              <li>
                <a href="#why-choose-us" className="hover:text-gray-300">
                  Why you choose Us
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-gray-300">
                  Contact us
                </a>
              </li>
            </ul>
          </div>

          {/* About Rentcars */}
          <div className="pl-0 md:pl-10 text-center md:text-left">
            <h4 className="font-semibold text-lg mb-4">About Rentcars</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#why-choose-us" className="hover:text-gray-300">
                  Why choose us
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-gray-300">
                  Our Story
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="pl-0 md:pl-10 text-center md:text-left">
            <h4 className="font-semibold text-lg mb-4">Follow Us</h4>
            <div className="flex justify-center md:justify-start gap-3">
              <a
                href="https://www.instagram.com/sales.bdrac?igsh=cjE0dGFuNHF3eXk0&utm_source=qr"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white text-[#0B2F6B] hover:bg-gray-200 transition"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://www.facebook.com/share/1CAFxsipxD/?mibextid=wwXIfr"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white text-[#0B2F6B] hover:bg-gray-200 transition"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="mailto:sales@bluediamondrentcar.com"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white text-[#0B2F6B] hover:bg-gray-200 transition"
              >
                <FaEnvelope size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@blue.diamond7627?_t=ZS-8zdbV4MKTw7&_r=1"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-white text-[#0B2F6B] hover:bg-gray-200 transition"
              >
                <FaTiktok size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-500 mt-12 pt-6 text-center text-sm text-gray-300 space-y-2">
          <p>
            Copyright {new Date().getFullYear()} • bluediamondsrentacar, All
            Rights Reserved
          </p>
          <p className="text-[0.6rem]">
            Designed & Developed by{" "}
            <a
              href="https://linkedin.com/in/hiba-fathima-000-ks"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white underline"
            >
              hibafathima
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
